import React from "react";
import "./Compo.css";
import FadeIn from "react-fade-in";
import ApiError from "../Error/ApiError.js";
import LoadAnim from "../App/LoadAnim.js";

class Compo extends React.Component {
  constructor(props) {
    super(props);

    //State storage - should be hooked up with mongoose

    //We use OnLoadPost to get latest stored DB post. Intended to use with cancel button.
    this.state = {
      composPage: null,
      title: "Konkurranser",
      games: [],
      enabledGames: [],
      error: false
    };

    //Bindings
    this.changePost = this.changePost.bind(this);
    this.cancelPost = this.cancelPost.bind(this);
    this.savePost = this.savePost.bind(this);
    this.modalPop = this.modalPop.bind(this);
    this.changeGame = this.changeGame.bind(this);
    this.setUrl = this.setUrl.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    await this.getComposPage();
  }

  setUrl() {
    if (this.props.location.search !== "") {
      let param = this.props.location.search.replace("?", "");
      param = param.split("&")[0];
      this.setState({ selectedGame: param });
    } else {
      this.props.history.push("?" + this.state.selectedGame);
    }
  }

  async getComposPage() {
    try {
      fetch("/api/pagedata/getComposPage", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          pragma: "no-cache",
          "cache-control": "no-cache"
        }
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data && data.length > 0 && data[0]) {
            let games = data[0].games;

            // Migration: if no games array exists but old game1-5 structure exists, migrate it
            if (!games && (data[0].game1Title || data[0].game2Title || data[0].game3Title || data[0].game4Title || data[0].game5Title)) {
              games = this.migrateOldGameStructure(data[0]);
            }

            this.setState({
              composPage: data[0],
              title: data[0].title || "Konkurranser",
              games: games || this.getDefaultGames(),
              updated: Date().slice(16, 24),
              error: false
            });
          } else {
            // Handle empty database case
            this.setState({
              composPage: {
                composOpen: false,
                composOpenPost: "Gaming competitions are coming soon!",
                composClosedPost: "Competitions are currently closed."
              },
              games: this.getDefaultGames(),
              updated: Date().slice(16, 24),
              error: false
            });
          }

          const games = this.state.games || this.getDefaultGames();
          let enabled = games.filter(game => game.active).map(game => game.id);
          this.setState({ enabledGames: enabled });
          this.setState({ selectedGame: enabled[0] });
          this.setUrl();
        })
        .catch(err => {
          this.setState({ error: true });
          console.log(err);
        });
    } catch (err) {
      this.setState({ error: true });
      console.log(err);
    }
  }

  changePost(newPost) {
    //Takes an event param, done automatically by eventhandler - see AppModal for handleChange
    this.setState({ post: newPost }); //Updates the state with new value
  }

  //Event for modal cancel button, sets Post state back to onLoadPost
  cancelPost(cancel) {
    this.setState({ post: this.state.onLoadPost });
    this.setState({ showModal: false });
  }
  //Event for modal save button, will push to DB, needs logic implementation
  savePost(newPost) {
    //Implement logic for saving post and refreshing the content
    this.setState({ onLoadPost: newPost });
  }

  modalPop(e) {
    //Trigger App's modal component... Toggles showModal true or false
    if (this.state.showModal === false) {
      this.setState({ showModal: true });
    } else {
      this.setState({ showModal: false });
    }
  }

  migrateOldGameStructure(oldData) {
    const games = [];

    for (let i = 1; i <= 5; i++) {
      const title = oldData[`game${i}Title`];
      const content = oldData[`game${i}Post`];
      const active = oldData[`game${i}Active`];

      if (title) {
        games.push({
          id: `game_${i}`,
          title: title,
          content: content || "",
          active: active || false,
          order: i
        });
      }
    }

    return games;
  }

  getDefaultGames() {
    return [
      {
        id: "game_1",
        title: "Counter-Strike 2",
        content: "Classic competitive FPS tournament.",
        active: false,
        order: 1
      },
      {
        id: "game_2",
        title: "League of Legends",
        content: "5v5 MOBA championship.",
        active: false,
        order: 2
      },
      {
        id: "game_3",
        title: "Rocket League",
        content: "Car soccer tournament.",
        active: false,
        order: 3
      }
    ];
  }

  changeGame(e) {
    this.setState({ selectedGame: e.target.name });
    this.props.history.push("?" + e.target.name);
  }

  render() {
    let compoSelector = [];

    if (this.state.composPage !== null && this.state.selectedGame !== undefined) {
      const activeGames = this.state.games.filter(game => game.active).sort((a, b) => a.order - b.order);

      compoSelector = activeGames.map(game => (
        <button
          key={game.id}
          name={game.id}
          onClick={this.changeGame}
          className={
            "btn btno nobord compobtn " +
            (this.state.selectedGame === game.id ? "btn-success" : "btn-info")
          }
        >
          {game.title}
        </button>
      ));
    }

    return (
      <div>
        {this.state.error !== true && this.state.composPage === null && (
          <LoadAnim />
        )}
        <FadeIn>
          {this.state.error && <ApiError />}
          {this.state.composPage !== null && (
            <div className="Info">
              <div className="row">
                <div className="col-centered">
                  <div className="">
                    <h1>{this.state.title}</h1>
                    {this.state.composPage.composOpen === true && (
                      <div
                        className="Post"
                        dangerouslySetInnerHTML={{
                          __html: this.state.composPage.composOpenPost
                        }}
                      />
                    )}
                    {this.state.composPage.composOpen === false && (
                      <div
                        className="Post"
                        dangerouslySetInnerHTML={{
                          __html: this.state.composPage.composClosedPost
                        }}
                      />
                    )}

                    <br></br>

                    {this.state.composPage.composOpen === true && (
                      <div className="CompoSelector">{compoSelector}</div>
                    )}

                    <br></br>

                    <br></br>
                    <br></br>
                    {this.state.composPage.composOpen === true &&
                      this.state.games
                        .filter(game => game.active && game.id === this.state.selectedGame)
                        .map(game => (
                          <div key={game.id} className="col-md-10 col-centered">
                            <h1>{game.title}</h1>
                            <br></br>
                            <div className="infoCard">
                              <br></br>
                              <div dangerouslySetInnerHTML={{ __html: game.content }}></div>
                              <br></br>
                            </div>
                          </div>
                        ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </FadeIn>
      </div>
    );
  }
}

export default Compo;



// WEBPACK FOOTER //
// ./src/Components/Compo/Compo.js